/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface SyncEventRequest
 */
export interface SyncEventRequest {
  /**
   *
   * @type {string}
   * @memberof SyncEventRequest
   */
  documentId?: string
  /**
   *
   * @type {string}
   * @memberof SyncEventRequest
   */
  siteId?: string
  /**
   *
   * @type {string}
   * @memberof SyncEventRequest
   */
  eventType?: string
}

export function SyncEventRequestFromJSON(json: any): SyncEventRequest {
  return SyncEventRequestFromJSONTyped(json, false)
}

export function SyncEventRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncEventRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    documentId: !exists(json, 'document_id') ? undefined : json['document_id'],
    siteId: !exists(json, 'site_id') ? undefined : json['site_id'],
    eventType: !exists(json, 'event_type') ? undefined : json['event_type']
  }
}

export function SyncEventRequestToJSON(value?: SyncEventRequest | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    document_id: value.documentId,
    site_id: value.siteId,
    event_type: value.eventType
  }
}
